import { Action } from '@ngrx/store';
import { CmxMapConfig } from '../../../../../shared/models/cmx-map-config/cmx-map-config';
import { ILocationMapState } from '../../reducers/location-map-reducer/location-map.reducer';

export const LOAD_MAP_INITIAL_STATE = '[Location map] initial state';
export const RENDER_MAP_ACTION = '[Location map] render map';
export const LOAD_MAP_FROM_JOBSITE_ACTION = '[Location map] load map from jobsite';

export class LoadMapInitialStateAction implements Action {
  readonly type = LOAD_MAP_INITIAL_STATE;

  constructor(public payload: ILocationMapState) {}
}

export class RenderMapAction implements Action {
  readonly type = RENDER_MAP_ACTION;

  constructor(public payload: CmxMapConfig) {}
}

export class LoadMapFromJobsiteAdderess implements Action {
  readonly type = LOAD_MAP_FROM_JOBSITE_ACTION;

  constructor() {}
}
/**
 * Export a type alias of all actions in this action group
 * so that reducers can easily compose action types
 */
export type LocationMapActions = RenderMapAction | LoadMapInitialStateAction | LoadMapFromJobsiteAdderess;
